import { useEffect, useState } from 'react';
import { GridRowsProp, GridColDef } from '@mui/x-data-grid';
import DataTable from '../../components/DataTable';
import { Box, Button, Grid, Pagination } from '@mui/material';
import { GLOBAL_CONSTANTS, ROUTES, TOASTER_CONFIGS } from '../../constants';
import { useNavigate } from 'react-router-dom';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import HttpsIcon from "@mui/icons-material/Https";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import { useEmployeeDeleteMutation, useEmployeeListMutation, useGuestEmployeeListMutation } from '../../service/apiSlices/accessApiService';
import { toast } from 'react-toastify';
import moment from 'moment';
import { checkEmpty } from '../../utils/helper';

const ManageEmployee = () => {
    const navigate = useNavigate();
    const [employeeListApiCall] = useEmployeeListMutation();
    const [guestListApiCall] = useGuestEmployeeListMutation();
    const [deleteApiCall] = useEmployeeDeleteMutation();
    const [GuestEmployeeActive, setGuestEmployeeActive] = useState(false)
    const [page, setPage] = useState(1);
    const [totalPage, setTotalCount] = useState(0);
    const [rowPerPage, setRowPerPage] = useState(10);
    const [hasProducts, setHasProducts] = useState(false);
    const [EmployeeList, setEmployeeList] = useState([]);
    const [GuestList, setGuestList] = useState([]);

    const rows: GridRowsProp = EmployeeList ?? [];
    const rowsGuest: GridRowsProp = GuestList ?? [];

    const navigateEditValue = (id: any) => {
        navigate(ROUTES.MANAGEEMPLOYEE_add + `/${id}`)
    }

    useEffect(() => {
        if (GuestEmployeeActive) {
            GetGuestListApiCall()
        } else {
            GetEmployeeListApiCall();
        }
    }, [page, rowPerPage, GuestEmployeeActive])

    const GetEmployeeListApiCall = async () => {
        var payload = { page: page, limit: rowPerPage }
        await employeeListApiCall(payload)
            .unwrap()
            .then((response) => {
                setEmployeeList(response?.result?.data);
                setTotalCount(response.result.total_page);
                setHasProducts(checkEmpty(response?.result?.data));
            })
            .catch(() => { })
    }

    const GetGuestListApiCall = async () => {
        var payload = { page: page, limit: rowPerPage }
        await guestListApiCall(payload)
            .unwrap()
            .then((response) => {
                setGuestList(response?.result?.data);
                setTotalCount(response.result.total_page);
                setHasProducts(checkEmpty(response?.result?.data));
            })
            .catch(() => { })
    }


    const columns: GridColDef[] = [
        { field: 'firstname', headerName: 'First Name', width: 200 },
        { field: 'lastname', headerName: 'Last Name', width: 200 },
        { field: 'email', headerName: 'Email', width: 250 },
        { field: 'reports_count', headerName: 'Reports count', width: 120 },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 250,
            renderCell: (params) => (
                <>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '25px', alignItems: 'center' }}>
                        <ModeEditIcon onClick={() => navigateEditValue(params.row.id)} style={{ cursor: 'pointer' }} />
                        {!params?.row?.is_active ? (
                            <div className="reject_btn_wrapper">
                                <div className="accept_btn_label" onClick={() => blockUnblockDeparment(params.row.id)}>
                                    De-Activated
                                </div>
                                <div className="lock_icon_wrapper">
                                    <HttpsIcon className="lock_icon" />
                                </div>
                            </div>
                        ) : (
                            <div className="accept_btn_wrapper">
                                <div className="unlock_icon_wrapper">
                                    <LockOpenTwoToneIcon className="unlock_icon" />
                                </div>
                                <div className="accept_btn_label" onClick={() => blockUnblockDeparment(params.row.id)}>
                                    Activated
                                </div>
                            </div>
                        )}
                    </div>
                </>
            ),
        },
    ];

    const columnsGuest: GridColDef[] = [
        { field: 'fullname', headerName: 'Name', width: 200 },
        { field: 'email', headerName: 'Email', width: 250 },
        { field: 'phone_number', headerName: 'Phone number', width: 200 },
        {
            field: 'created_on', headerName: 'Created Date', width: 150,
            renderCell: (params) => (
                <>
                    {moment(params.row.created_on).format('DD/MM/YYYY')}
                </>
            ),
        },
        { field: 'reports_count', headerName: 'Reports count', width: 150 },
    ];


    const blockUnblockDeparment = (id: any) => {
        deleteApiCall(id)
            .unwrap()
            .then((response) => {
                GetEmployeeListApiCall();
                toast.success(response?.message, TOASTER_CONFIGS);
            })
            .catch((error) => {
                toast.error(error?.data?.message, TOASTER_CONFIGS);
            })

    }

    /**Handle row per page change */
    const onRowChange = (event: any) => {
        setPage(1);
        setRowPerPage(parseInt(event.target.value));
    };

    /* Handle page change */
    const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
        setPage(newPage);
    };

    return (
        <div>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'row', gap: '15px', alignItems: 'center' }}>
                    <Button type="button" variant="contained" onClick={() => {
                        setPage(1);
                        setGuestEmployeeActive(false);
                    }}
                        sx={{ mb: 2, background: !GuestEmployeeActive ? `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` : "#1976d2" }}>
                        Employee List
                    </Button>
                    <Button type="button" variant="contained" onClick={() => {
                        setPage(1);
                        setGuestEmployeeActive(true);
                    }}
                        sx={{ mb: 2, background: GuestEmployeeActive ? `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` : "#1976d2" }}>
                        Guest List
                    </Button>
                </div>

                {!GuestEmployeeActive && (
                    <Button type="button" variant="contained" onClick={() => navigate(ROUTES.MANAGEEMPLOYEE_add)}
                        sx={{ mb: 2, background: `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` }}>
                        Add Employee
                    </Button>
                )}

            </Box>
            {GuestEmployeeActive ? (
                <DataTable rows={rowsGuest} columns={columnsGuest} />
            ) : (
                <DataTable rows={rows} columns={columns} />
            )}

            {hasProducts && (
                <div className="tablePagination">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={7}>
                            <div className="pagination-wrap">
                                <Pagination
                                    count={totalPage}
                                    page={page}
                                    onChange={handleChangePage}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <div className="rows-per-page">
                                <p>Rows per page</p>
                                <select
                                    className="rows-select"
                                    value={rowPerPage}
                                    onChange={onRowChange}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                </select>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            )}
        </div>
    )
}

export default ManageEmployee